import { contentfulDateToISO } from "./normalizeCalendar";

/**
 * @param {object | undefined} fields
 * @param {Date} [now=new Date()]
 */
export function normalizeSiteAnnouncement(fields, now = new Date()) {
  if (!fields?.active) return null;

  const message = fields.message?.trim();
  if (!message) return null;

  const announcementId = fields.announcementId?.trim() || "default";
  const startDate = fields.startDate
    ? contentfulDateToISO(fields.startDate)
    : null;
  const endDate = fields.endDate ? contentfulDateToISO(fields.endDate) : null;
  const today = contentfulDateToISO(now);

  if (startDate && today < startDate) return null;
  if (endDate && today > endDate) return null;

  const variant = fields.variant?.trim().toLowerCase() || "info";
  const allowedVariants = ["info", "feature", "meet", "alert"];
  const safeVariant = allowedVariants.includes(variant) ? variant : "info";

  return {
    id: announcementId,
    message,
    linkUrl: fields.linkUrl?.trim() || "",
    linkText: fields.linkText?.trim() || "Learn more",
    variant: safeVariant,
    dismissible: fields.dismissible !== false,
  };
}

export function getAnnouncementDismissKey(id) {
  return `ace-dismissed-announcement-${id}`;
}

export function isAnnouncementDismissed(id) {
  if (typeof window === "undefined") return false;
  return localStorage.getItem(getAnnouncementDismissKey(id)) === "true";
}

export function dismissAnnouncement(id) {
  if (typeof window === "undefined") return;
  localStorage.setItem(getAnnouncementDismissKey(id), "true");
}
